import React, { useCallback } from 'react';
import { Product } from 'src/@types/basket';
import useLocalStorage from 'src/hooks/useLocalStorage';

export type ICartState = {
  cartList: Product[];
  setCartList: (item: any) => void;
  deleteCartItem: (id: string) => void;
  addCartItem: (product: Product) => void;
  checkIfProductInCart: (id: string) => boolean;
  updateCartItem: (id: string, data: any) => void;
  clearCart: () => void;
}

export const CartContext = React.createContext<ICartState>({
  cartList: [],
  setCartList: () => {},
  deleteCartItem: () => {},
  addCartItem: () => {},
  checkIfProductInCart: () => true,
  updateCartItem: () => {},
  clearCart: () => {},
});

type CartProviderProps = {
  children: React.ReactNode;
};

type Id = Partial<{ id: string }>;

export const CartContextProvider = ({ children }: CartProviderProps) => {
  const [cartList, setCartList] = useLocalStorage('cartItems', []);

  const deleteCartItem = (id: string) => {
    if (id) {
      setCartList(cartList.filter((item: Id) => item.id !== id));
    }
  }

  const addCartItem = (product: Product) => {
    const isDuplicated = cartList.find((item: Id) => item.id === product.id);
    
    if (!isDuplicated && product && cartList.length < 1) {
      setCartList([...cartList, product] as any);
    }
  }

  const clearCart = useCallback(() => {
    setCartList([]);
  }, [setCartList]);

  const checkIfProductInCart = (id: string) => {
    return !!cartList?.find((item: Id) => item.id === id);
  }

  const updateCartItem = (id: string, data: any) => {
    if (!id) {
      return;
    }

    const newArr = cartList.map((el: any) => {
      if (el?.id === id) {
        return {
          ...el,
          ...data, 
        }
      }

      return el;
    })

    setCartList(newArr);
  }

  return (
    <CartContext.Provider
      value={{
        cartList,
        setCartList,
        deleteCartItem,
        addCartItem,
        checkIfProductInCart,
        updateCartItem,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}